export default "__VITE_ASSET__DKCj6qD4__"